import React from "react";
import FormObjectViewer from "./FormTypes/FormObjectViewer";
import FormBooleanViewer from "./FormTypes/FormBooleanViewer";
import FormArrayViewer from "./FormTypes/FormArrayViewer";
import FormTextFieldViewer from "./FormTypes/FormTextFieldViewer";

interface FormPropertiesSwitcherProps {
  type: string;
  selectedNode: any;
  handleStateChange: (item: any) => void;
}

const FormPropertiesSwitcher = ({
  type,
  selectedNode,
  handleStateChange,
}: FormPropertiesSwitcherProps) => {
  const renderTypeSwitch = (typeObj: string) => {
    switch (typeObj) {
      case "array":
        return (
          <FormArrayViewer
            inputPropertyData={selectedNode}
            onFormStateChange={handleStateChange}
          />
        );
      case "string":
        return (
          <FormTextFieldViewer
            inputPropertyData={selectedNode}
            onFormStateChange={handleStateChange}
          />
        );
      case "boolean":
        return (
          <FormBooleanViewer
            inputPropertyData={selectedNode}
            onFormStateChange={handleStateChange}
          />
        );
      default:
        return (
          <FormObjectViewer
            inputPropertyData={selectedNode}
            onFormStateChange={handleStateChange}
          />
        );
    }
  };

  return <div> {renderTypeSwitch(type)}</div>;
};

export default FormPropertiesSwitcher;
